/**
 * Whether there is an earlier entry in this app's history to go back to.
 * React Router stores the entry index in `history.state.idx`; it is 0 on the
 * first page of a visit (for example when opened from an email link).
 */
export function canGoBack(): boolean {
  const state = window.history.state as { idx?: number } | null

  return (state?.idx ?? 0) > 0
}
